<template>
    <v-dialog max-width="600px" v-model="dialog">
        <!-- <v-btn flat slot="activator" color="primary">Add a quote or Excerpt</v-btn> -->
        <v-btn slot="activator" class="mx-2" flat fab>
        <v-icon dark>add</v-icon>
        </v-btn>
        <v-card>
            <v-card-title>
                <span class="headline font-weight-bold">Add a Competing Product:</span> 
                <!-- <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify"
                outline>
                You have seleect
              </v-alert>  -->
            </v-card-title>

            <v-card-text>
                <v-form class="px-3" ref="form">
                    <v-textarea outline :label="productnameLabeltext" v-model="productnametext" :hint="productnameHint" :rules="textInputRules"></v-textarea>
                    <v-textarea outline :label="productparentcompanyLabeltext" v-model="productparentcompanytext" :hint="productparentcompanyHint" :rules="textInputRules"></v-textarea>
                    
                    <v-textarea outline 
                        :label="productlistoffeaturesLabeltext" 
                        v-model="productlistoffeaturestext" 
                        :hint="productlistoffeaturesHint" 
                        :rules="textInputRules"></v-textarea>

                    <v-textarea outline 
                        :label="productlistoffeaturestextincludedincurrentofferingLabeltext" 
                        v-model="productlistoffeaturestextincludedincurrentoffering" 
                        :hint="productlistoffeaturestextincludedincurrentofferingHint" 
                        :rules="textInputRules"></v-textarea>
                    
                    
                    <!-- <v-checkbox v-model="firstprefquotemetricsuggestionsuitability" label="One or more metric(s) can be added based on this quote"></v-checkbox> -->
                    <!-- <v-radio-group v-model="row" row>
                        <v-radio label="Option 1" value="radio-1"></v-radio>
                        <v-radio label="Option 2" value="radio-2"></v-radio>
                        </v-radio-group> -->
                                        <!-- <v-btn flat color="primary" @click="submit" :loading="loading">Add Detail</v-btn>  -->
                    <v-btn flat color="primary" @click="dummySubmit" :loading="loading">Add Competing offering</v-btn> 
                    <!-- <v-btn flat to="/bifdashboard" color="primary" class="mx-2 mt-3" :loading="loading">Add Story</v-btn> -->
                    <v-btn flat @click="dialog = false">Cancel</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
    name: '',
    data() {
        return{
            productnametext: 'Todoist', 
            productnameLabeltext: 'What is the name of the product?', 
            productnameHint: 'Enter the name of the competing product here', 
            productparentcompanytext: 'Doist.com', 
            productparentcompanyLabeltext: 'Which organization does this product belong to?', 
            productparentcompanyHint: 'Enter the name of the parent company of the product here', 
            productlistoffeaturestext: 'backup tasks to the cloud, labeling of tasks, smart schedule of tasks', 
            productlistoffeaturesLabeltext: 'What are the features of this competing offering? ', 
            productlistoffeaturesHint: 'Mention each feature separated by a comma', 
            productlistoffeaturestextincludedincurrentoffering: 'backup tasks to the cloud, smart schedule of tasks',
            productlistoffeaturestextincludedincurrentofferingLabeltext: 'Which of these features are to be included in your current solution offering?',
            productlistoffeaturestextincludedincurrentofferingHint: 'Mention each feature separated by a comma',
            //items: ['Pain Point', 'User Story', 'Both Enterprise and Consumer', 'Not Sure'],
            textInputRules: [
                    v => !!v || 'This field is required',
                    v => v.length >= 3 || 'Minimum length is 3 characters'
                ],
            loading: false,
            dialog: false
        }
    },
    methods: {
        submit() {

             if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            //details = {}

            const competingproduct = {
                productnametext: this.productnametext,
                productparentcompanytext: this.productparentcompanytext,
                productlistoffeaturestext: this.productlistoffeaturestext,
                productlistoffeaturestextincludedincurrentoffering: this.productlistoffeaturestextincludedincurrentoffering

            }

            //details['prefs'] = firstprefdetails;
 

            //
            //xuWrU7qOYXxLjL97QoCe

        var dbref = db.collection('projects').doc(this.getProjectID()).collection('competingproducts');

        dbref.add(competingproduct).then(() =>{
            //console.log('Collection quotes created')
                      this.loading = false;
          this.dialog = false;
          this.$emit('marketplayeradded')
        });


    //     db.collection('projects').doc('Yx3r6dHUeFFdGvY6Acvy').collection('quotesregardingfirstprefsolutionconcept').update(quote).then(() => {
    //       //console.log("added to db!", docRef.id)
    //       this.loading = false;
    //       this.dialog = false;
    //       this.$emit('quoteconfirmed')
    //    });

             }
        },
        dummySubmit(){
            this.loading = false;
          this.dialog = false;

        },
    getProjectID(){
      return gvars.PROJECTID;
    } 
    }
}
</script>
